/* USER */
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const LOGIN_EMAIL = 'LOGIN_EMAIL';
export const SET_USER_INFO = 'SET_USER_INFO';
export const LOGIN_FACEBOOK = 'LOGIN_FACEBOOK';
export const SHOW_REG_MODAL = 'SHOW_REG_MODAL';
export const SHOW_AUTH_MODAL = 'SHOW_AUTH_MODAL';
export const CHANGE_VISIBLE_RESTORE_PASSWORD_FIRST_STEP_MODAL = 'CHANGE_VISIBLE_RESTORE_PASSWORD_FIRST_STEP_MODAL';
export const CHANGE_VISIBLE_RESTORE_PASSWORD_SECOND_STEP_MODAL = 'CHANGE_VISIBLE_RESTORE_PASSWORD_SECOND_STEP_MODAL';
export const CHANGE_FAVORITES = 'CHANGE_FAVORITES';
export const SHOW_WRONG_DATA_MESSAGE = 'SHOW_WRONG_DATA_MESSAGE';

/* HOME */
export const SET_LAST_OBJECTS = 'SET_LAST_OBJECTS';

/* LANGUAGES */
export const SET_I18N = 'SET_I18N';
export const SET_ALL_LANGUAGES = 'SET_ALL_LANGUAGES';
export const SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE';

/* SEARCH */
export const SET_PAGE = 'SET_PAGE';
export const SET_ORDER = 'SET_ORDER';
export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_MIN_AREA = 'SET_MIN_AREA';
export const SET_MAX_AREA = 'SET_MAX_AREA';
export const SET_PLACE_ID = 'SET_PLACE_ID';
export const SET_MAP_DATA = 'SET_MAP_DATA';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
export const SET_TYPE_TERM = 'SET_TYPE_TERM';
export const SET_AMENITIES = 'SET_AMENITIES';
export const SET_MIN_PRICE = 'SET_MIN_PRICE';
export const SET_MAX_PRICE = 'SET_MAX_PRICE';
export const SET_COUNT_BEDS = 'SET_COUNT_BEDS';
export const SET_RANGE_AREA = 'SET_RANGE_AREA';
export const SET_LIFESTYLES = 'SET_LIFESTYLES';
export const SET_SEARCH_TYPE = 'SET_SEARCH_TYPE';
export const SET_RANGE_PRICE = 'SET_RANGE_PRICE';
export const SET_POOL_VALUES = 'SET_POOL_VALUES';
export const SET_COUNT_GUESTS = 'SET_COUNT_GUESTS';
export const SET_FLOOR_VALUES = 'SET_FLOOR_VALUES';
export const SET_VIEWS_VALUES = 'SET_VIEWS_VALUES';
export const SET_SEARCH_RESULT = 'SET_SEARCH_RESULT';
export const SET_OUR_EXCLUSIVE = 'SET_OUR_EXCLUSIVE';
export const SET_GARAGE_VALUES = 'SET_GARAGE_VALUES';
export const SET_GARDEN_VALUES = 'SET_GARDEN_VALUES';
export const SET_KITCHEN_VALUES = 'SET_KITCHEN_VALUES';
export const SET_COUNT_BEDROOMS = 'SET_COUNT_BEDROOMS';
export const SET_EASY_FURNITURE = 'SET_EASY_FURNITURE';
export const SET_HORIZONTAL_MODE = 'SET_HORIZONTAL_MODE';
export const SET_TYPE_APARTMENTS = 'SET_TYPE_APARTMENTS';
export const SET_COUNT_BATHROOMS = 'SET_COUNT_BATHROOMS';
export const SET_DATE_END_SEARCH = 'SET_DATE_END_SEARCH';
export const SET_NEW_TYPE_VALUES = 'SET_NEW_TYPE_VALUES';
export const SET_CONDITION_VALUES = 'SET_CONDITION_VALUES';
export const SET_DATE_START_SEARCH = 'SET_DATE_START_SEARCH';
export const SET_ORIENTATION_VALUES = 'SET_ORIENTATION_VALUES';
export const SET_IS_SHOW_ALL_FILTERS = 'SET_IS_SHOW_ALL_FILTERS';
export const SET_IS_SHOW_ADVANCED_SEARCH = 'SET_IS_SHOW_ADVANCED_SEARCH';
export const SET_MIN_YEAR_OF_CONSTRUCTION = 'SET_MIN_YEAR_OF_CONSTRUCTION';
export const SET_MAX_YEAR_OF_CONSTRUCTION = 'SET_MAX_YEAR_OF_CONSTRUCTION';
export const SET_RANGE_YEAR_OF_CONSTRUCTION = 'SET_RANGE_YEAR_OF_CONSTRUCTION';

/* OBJECT */
export const GET_CALENDARS = 'GET_CALENDARS';
export const ADD_CALENDARS = 'ADD_CALENDARS';
export const GET_OBJECT_BY_ID = 'GET_OBJECT_BY_ID';
export const BOOKING_CALCULATE = 'BOOKING_CALCULATE';
export const SET_SHOW_ORIGINAL = 'SET_SHOW_ORIGINAL';
export const SET_DATE_END_OBJECT = 'SET_DATE_END_OBJECT';
export const SET_DATE_START_OBJECT = 'SET_DATE_START_OBJECT';
export const SET_IS_NEED_CALCULATE = 'SET_IS_NEED_CALCULATE';
export const SET_YOU_WILL_ALSO_LIKE = 'SET_YOU_WILL_ALSO_LIKE';
export const SET_IS_SHOW_CALENDAR_LOADING = 'SET_IS_SHOW_CALENDAR_LOADING';
export const PROPERTY_CHANGE_BACKGROUND_LOADING = 'PROPERTY_CHANGE_BACKGROUND_LOADING';

/* REVIEWS */
export const GET_ALL_REVIEWS = 'GET_ALL_REVIEWS';

/* CONFIGURATION */
export const SET_CONFIGURATION = 'SET_CONFIGURATION';
export const SET_GOOGLE_API_INIT = 'SET_GOOGLE_API_INIT';

/* CREATING OBJECT */
export const CREATING_PROPERTY_UPDATE_DAYS = 'CREATING_PROPERTY_UPDATE_DAYS';
export const UPDATE_FIELD = 'UPDATE_FIELD';
export const DELETE_IMAGE = 'DELETE_IMAGE';
export const SET_REDIRECT = 'SET_REDIRECT';
export const CREATING_OBJECT = 'CREATING_OBJECT';
export const CREATING_PROPERTY_SET_CURRENT_DAYS = 'CREATING_PROPERTY_SET_CURRENT_DAYS';
export const CREATING_PROPERTY_CHANGE_CALENDAR_LOADING = 'CREATING_PROPERTY_CHANGE_CALENDAR_LOADING';
export const SET_PRICES_VALID = 'SET_PRICES_VALID';
export const SET_OTHER_VALID = 'SET_OTHER_VALID';
export const SET_ADDRESS_VALID = 'SET_ADDRESS_VALID';
export const GET_CREATED_OBJECT = 'GET_CREATED_OBJECT';
export const UPDATE_PHOTO_ORDERS = 'UPDATE_PHOTO_ORDERS';
export const UPDATE_MAIN_PHOTO_URL = 'UPDATE_MAIN_PHOTO_URL';
export const ADD_EXTERNAL_CALENDAR = 'ADD_EXTERNAL_CALENDAR';
export const SET_PROGRESS_BAR_INFO = 'SET_PROGRESS_BAR_INFO';
export const SET_NEED_CREATE_OBJECT = 'SET_NEED_CREATE_OBJECT';
export const DELETE_EXTERNAL_CALENDAR = 'DELETE_EXTERNAL_CALENDAR';
export const SET_IS_SHOW_PROGRESS_BAR = 'SET_IS_SHOW_PROGRESS_BAR';
export const SET_REDIRECT_TO_OBJECT_PAGE = 'SET_REDIRECT_TO_OBJECT_PAGE';
export const SET_GENERAL_INFORMATION_VALID = 'SET_GENERAL_INFORMATION_VALID';
export const SET_EXPORT_VALUE = 'SET_EXPORT_VALUE';

/* ORDERS */
export const CREATING_ORDER = 'CREATING_ORDER';

/* API */
export const SET_SHOW_API_ERROR_MODAL = 'SET_SHOW_API_ERROR_MODAL';
export const SET_API_ERROR_MODAL_SETTINGS = 'SET_API_ERROR_MODAL_SETTINGS';


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js